export default "__VITE_ASSET__vzLqD46n__"